import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AIPEmailBody } from '@wlocalhost/ngx-email-builder';
import { FormControl } from "@angular/forms";

@Component({
  selector: 'tail-email-body',
  templateUrl: './email-body.component.html',
  styleUrls: ['./email-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailBodyComponent extends AIPEmailBody {
  control = new FormControl()
  templateshow:boolean = false;
  backButtonshow:boolean = false;
}
